<div class="node-terminal flow-node">
  @if (showIds()) {
    <span class="debug-id">{{ data.id }}</span>
  }

  <div class="node-actions">
    @if (!(data.nodeData | hideNodeAction: [nodeTypeEnum.End, nodeTypeEnum.Terminate])) {
      <span class="action">
        <i
          class="mynaui-pencil clickable"
          (pointerdown)="$event.stopPropagation()"
          (click)="editNode($event, data)"></i>
      </span>
    }

    <span class="action">
      <i class="mynaui-trash clickable" (pointerdown)="$event.stopPropagation()" (click)="removeNode($event, data)"></i>
    </span>
  </div>
  <div
    class="node-wrap"
    [class.start]="data.nodeData.type === nodeTypeEnum.Start"
    [style.background-color]="data.nodeData | nodeBackgroundColor">
    @if (data | nodeWarningTooltip) {
      <i
        class="mynaui-danger-triangle warning"
        data-testid="warning"
        [pTooltip]="tooltipContent"
        tooltipStyleClass="neqto-tooltip warning"></i>
      <ng-template #tooltipContent>
        <div class="tooltip-content">
          <p>{{ 'flow.node.tooltip.parameters.required' | translate }}</p>
        </div>
      </ng-template>
    }
    <div
      class="icon"
      data-testid="icon"
      [attr.aria-label]="data.label"
      (pointerdown)="$event.stopPropagation()"
      (dblclick)="handleDoubleClick($event)">
      <i [class]="data.nodeData.icon | nodeIcon"></i>
    </div>
  </div>

  @for (output of data.outputs | keyvalue: sortByIndex; track output) {
    <app-node-socket
      [data]="data"
      [input]="output"
      [emit]="emit"
      [seed]="seed"
      [showLabel]="false"
      [nodeSocketType]="socketType.OUTPUT"
      nodeType="terminal" />
  }

  @for (input of data.inputs | keyvalue: sortByIndex; track input) {
    <app-node-socket
      [data]="data"
      [input]="input"
      [emit]="emit"
      [seed]="seed"
      [nodeSocketType]="socketType.INPUT"
      nodeType="terminal"
      [showLabel]="false" />
  }
</div>
